// // Raw Exam Data - start
// export const FETCH_RAW_EXAM_DATA_REQUEST = 'FETCH_RAW_EXAM_DATA_REQUEST';
// export const FETCH_RAW_EXAM_DATA_SUCCESS = 'FETCH_RAW_EXAM_DATA_SUCCESS';
// export const FETCH_RAW_EXAM_DATA_FAILURE = 'FETCH_RAW_EXAM_DATA_FAILURE';

// export const REFRESH_RAW_EXAM_DATA_REQUEST = 'REFRESH_RAW_EXAM_DATA_REQUEST';
// export const REFRESH_RAW_EXAM_DATA_SUCCESS = 'REFRESH_RAW_EXAM_DATA_SUCCESS';   
// export const REFRESH_RAW_EXAM_DATA_FAILURE = 'REFRESH_RAW_EXAM_DATA_FAILURE';
// // Raw Exam Data - end

// // Unread Exam Data - start
// export const FETCH_UNREAD_EXAM_DATA_REQUEST = 'FETCH_UNREAD_EXAM_DATA_REQUEST';
// export const FETCH_UNREAD_EXAM_DATA_SUCCESS = 'FETCH_UNREAD_EXAM_DATA_SUCCESS';
// export const FETCH_UNREAD_EXAM_DATA_FAILURE = 'FETCH_UNREAD_EXAM_DATA_FAILURE';

// export const REFRESH_UNREAD_EXAM_DATA_REQUEST = 'REFRESH_UNREAD_EXAM_DATA_REQUEST';
// export const REFRESH_UNREAD_EXAM_DATA_SUCCESS = 'REFRESH_UNREAD_EXAM_DATA_SUCCESS';   
// export const REFRESH_UNREAD_EXAM_DATA_FAILURE = 'REFRESH_UNREAD_EXAM_DATA_FAILURE';
// // Unread Exam Data - end

// // TAT Data - start
// export const FETCH_TAT_DATA_REQUEST = 'FETCH_TAT_DATA_REQUEST';
// export const FETCH_TAT_DATA_SUCCESS = 'FETCH_TAT_DATA_SUCCESS';
// export const FETCH_TAT_DATA_FAILURE = 'FETCH_TAT_DATA_FAILURE';
// // TAT Data - end

// // Miscellaneous Site Data - start
// export const FETCH_MISC_SITE_DATA_REQUEST = 'FETCH_MISC_SITE_DATA_REQUEST';
// export const FETCH_MISC_SITE_DATA_SUCCESS = 'FETCH_MISC_SITE_DATA_SUCCESS';
// export const FETCH_MISC_SITE_DATA_FAILURE = 'FETCH_MISC_SITE_DATA_FAILURE';

// export const FETCH_SITES_DROPDOWN_REQUEST = 'FETCH_SITES_DROPDOWN_REQUEST';
// export const FETCH_SITES_DROPDOWN_SUCCESS = 'FETCH_SITES_DROPDOWN_SUCCESS';
// export const FETCH_SITES_DROPDOWN_FAILURE = 'FETCH_SITES_DROPDOWN_FAILURE';

// export const FETCH_PRACTICE_SITE_MAPPING_REQUEST = 'FETCH_PRACTICE_SITE_MAPPING_REQUEST';
// export const FETCH_PRACTICE_SITE_MAPPING_SUCCESS = 'FETCH_PRACTICE_SITE_MAPPING_SUCCESS';
// export const FETCH_PRACTICE_SITE_MAPPING_FAILURE = 'FETCH_PRACTICE_SITE_MAPPING_FAILURE';

// export const SAVE_UPDATE_MISC_SITES_REQUEST = 'SAVE_UPDATE_MISC_SITES_REQUEST';
// export const SAVE_UPDATE_MISC_SITES_SUCCESS = 'SAVE_UPDATE_MISC_SITES_SUCCESS';
// export const SAVE_UPDATE_MISC_SITES_FAILURE = 'SAVE_UPDATE_MISC_SITES_FAILURE';
// // Miscellaneous Site Data - end

// // Read Exam Data - Start
// export const FETCH_EXAM_DATA_READ_REQUEST = 'FETCH_EXAM_DATA_READ_REQUEST';
// export const FETCH_EXAM_DATA_READ_SUCCESS = 'FETCH_EXAM_DATA_READ_SUCCESS';
// export const FETCH_EXAM_DATA_READ_FAILURE = 'FETCH_EXAM_DATA_READ_FAILURE';

// export const EXPORT_EXAM_DATA_READ_REQUEST = 'EXPORT_EXAM_DATA_READ_REQUEST';
// export const EXPORT_EXAM_DATA_READ_SUCCESS = 'EXPORT_EXAM_DATA_READ_SUCCESS';
// export const EXPORT_EXAM_DATA_READ_FAILURE = 'EXPORT_EXAM_DATA_READ_FAILURE';
// // Read Exam Data End 

// //Exam Data - start
// export const FETCH_EXAM_DATA_REQUEST = 'FETCH_EXAM_DATA_REQUEST';
// export const FETCH_EXAM_DATA_SUCCESS = 'FETCH_EXAM_DATA_SUCCESS';
// export const FETCH_EXAM_DATA_FAILURE = 'FETCH_EXAM_DATA_FAILURE';

// //Exam Data - end

// //Exam Data Dropdown Options - start
// export const FETCH_EXAM_DROPDOWN_OPTIONS_REQUEST = 'FETCH_EXAM_DROPDOWN_OPTIONS_REQUEST';
// export const FETCH_EXAM_DROPDOWN_OPTIONS_SUCCESS = 'FETCH_EXAM_DROPDOWN_OPTIONS_SUCCESS';
// export const FETCH_EXAM_DROPDOWN_OPTIONS_FAILURE = 'FETCH_EXAM_DROPDOWN_OPTIONS_FAILURE';

// //Exam Data Dropdown Options - end


// // Get Recalculate Data
// export const FETCH_RECALCULATE_DATA_REQUEST = 'FETCH_RECALCULATE_DATA_REQUEST';
// export const FETCH_RECALCULATE_DATA_SUCCESS = 'FETCH_RECALCULATE_DATA_SUCCESS';
// export const FETCH_RECALCULATE_DATA_FAILURE = 'FETCH_RECALCULATE_DATA_FAILURE';

// // Exam data record date
// export const UPDATE_EXAM_DATA_RECORD_DATE_REQUEST = 'UPDATE_EXAM_DATA_RECORD_DATE';
// export const UPDATE_EXAM_DATA_RECORD_DATE_SUCCESS = 'UPDATE_EXAM_DATA_RECORD_DATE_SUCCESS';
// export const UPDATE_EXAM_DATA_RECORD_DATE_FAILURE = 'UPDATE_EXAM_DATA_RECORD_DATE_FAILURE';


// Update Exam Reducer

export const UPDATE_EXAM_REDUCER = 'UPDATE_EXAM_REDUCER';